<template>
  <section>
    <div class="row justify-content-center">
      <template v-for="leilao in getLeiloesListados">
        <leilao-card :key="leilao.id" classeRaiz="col-10 col-sm-10 col-md-6 col-lg-3" :leilao="leilao.item" />
      </template>
      <div class="col-12 text-center my-5"
        v-if="!getLeiloesStatusLoading && getLeiloesStatus && getLeiloesStatus.length == 0">
        <h6 class="text-muted">NÃO HÁ LEILÕES NESTE STATUS</h6>
      </div>
      <h4 class="title mb-5 mt-5 verTodos text-center" v-if="getLeiloesStatusLoading">CARREGANDO...</h4>
    </div>
    <div class="center d-flex" v-if="getIsNextPage">
      <h4 class="title mb-5 mt-5 verTodos" @click="carregarMaisLeiloes" v-if="!getLeiloesStatusLoading">CARREGAR MAIS
        LEILÕES</h4>
    </div>
  </section>
</template>

<script>
import LeilaoCard from '@/components/LeilaoCard.vue';
import { mapActions, mapGetters, mapMutations } from 'vuex';
export default {
  components: {
    LeilaoCard,
  },
  props: {
    status: { type: String, required: true },
    slug: { type: String, required: true },
  },
  data() {
    return {
      pageNumber: 0,
    };
  },
  computed: {
    ...mapGetters(['getIsNextPage']),
    statusUppercase() {
      return this.status.toUpperCase();
    },
    getLeiloesStatus() {
      return this.$store.getters['getLeiloes' + this.statusUppercase.charAt(0) + this.statusUppercase.slice(1).toLowerCase()];
    },
    getLeiloesStatusLoading() {
      return this.$store.getters['getLeiloes' + this.statusUppercase.charAt(0) + this.statusUppercase.slice(1).toLowerCase() + 'Loading'];
    },
    getLeiloesListados() {
      const lista = [];
      if (this.getLeiloesStatus && this.getLeiloesStatus.length) {
        this.getLeiloesStatus.forEach((item) => lista.push({ id: item.id, parceiro: false, item }));
      }
      return lista.sort((a, b) => new Date(a.item.dataLeilao || a.item.pracas?.[0] || 0) - new Date(b.item.dataLeilao || b.item.pracas?.[0] || 0));
    },
  },
  methods: {
    ...mapActions(['setLeiloesPorStatusLeiloeiro']),
    ...mapMutations(['IS_NEXT_PAGE']),
    carregarMaisLeiloes() {
      this.pageNumber++;
    },
    limparLista() {
      this.$store.commit('SET_LEILOES_' + this.statusUppercase);
    },
  },
  watch: {
    pageNumber(value, oldvalue) {
      if (value == oldvalue) return;

      this.setLeiloesPorStatusLeiloeiro({
        pageSize: 4,
        pageNumber: this.pageNumber,
        status: this.status,
        slug: this.slug,
      });
    },
  },
  async created() {
    this.pageNumber++;
  },
  destroyed() {
    this.limparLista();
    this.IS_NEXT_PAGE();
  },
};
</script>

<style scoped>
.verTodos {
  color: #171d1c;
  cursor: pointer;
}

h4 {
  font-size: 1rem;
}
</style>
